export class EnvironmentConfig {
  production: boolean;
  development: boolean;
  hmr: boolean;
  integrations: IntegrationsConfig;
  featureFlags: FeatureFlag;
  apiGatewayUrl: string;
}

export class IntegrationsConfig {
  helloSignTestMode: boolean;
}

export class FeatureFlag {
}

export const configs = {
  'localhost': {
    production: false,
    development: true,
    hmr: false,
    apiGatewayUrl: 'http://localhost:64661/',
    integrations: {
      helloSignTestMode: true
    },
    featureFlags: {
    }
  },
  'jobs.dev.keldair.com': {
    production: false,
    development: false,
    hmr: false,
    apiGatewayUrl: 'https://job-gateway.dev.keldair.com/',
    integrations: {
      helloSignTestMode: true
    },
    featureFlags: {
    }
  },
  'jobs.keldair.com': {
    production: true,
    development: false,
    hmr: false,
    apiGatewayUrl: 'https://job-gateway.keldair.com/',
    integrations: {
      helloSignTestMode: false
    },
    featureFlags: {
    }
  },
  'jobs.citysuitehr.com': {
    production: true,
    development: false,
    hmr: false,
    apiGatewayUrl: 'https://job-gateway.citysuitehr.com/',
    integrations: {
      helloSignTestMode: false
    },
    featureFlags: {
    }
  },
  'jobs.connect-ats.com': {
    production: true,
    development: false,
    hmr: false,
    apiGatewayUrl: 'https://job-gateway.connect-ats.com/',
    integrations: {
      helloSignTestMode: false
    },
    featureFlags: {
    }
  },
  'jobs.keldairaps.com': {
    production: true,
    development: false,
    hmr: false,
    apiGatewayUrl: 'https://job-gateway.keldairaps.com/',
    integrations: {
      helloSignTestMode: false
    },
    featureFlags: {
    }
  },
  'jobs.constructhire.com': {
    production: true,
    development: false,
    hmr: false,
    apiGatewayUrl: 'https://job-gateway.constructhire.com/',
    integrations: {
      helloSignTestMode: false
    },
    featureFlags: {
    }
  },
  'empty': {
    production: false,
    development: false,
    hmr: false,
    apiGatewayUrl: '',
    integrations: {
      helloSignTestMode: true
    },
    featureFlags: {
    }
  }
};
